import { useWorkflowContext } from "../../../WorkflowContext"
import useUndo from "../../Utils/Undo";
import GenericLabel from "../../Utils/GenericLabel"

export default function ComputeServerSelector( props ){
    const {workflow} = useWorkflowContext();
    const { updateWorkflow } = useUndo();

    // Id of Action we are editing
    const id = props.id


    return (
        <div id="compute-server-selector">
            <GenericLabel size={"20px"} value={"Compute Server"} required={true}>

            <select placeholder="FaaSServer" onChange={(e)=> {

                const type = workflow.ActionList[id].Type;
                const faasServer = e.target.value;

                updateWorkflow({
                ...workflow,
                ActionList: {
                    ...workflow.ActionList,
                    [id]: {
                        ...workflow.ActionList[id],
                        FaaSServer: faasServer
                    }
                }

                })
            }} type="text" value={workflow.ActionList[id].FaaSServer}>
                <option value={""}> NONE </option>
                {Object.entries(workflow.ComputeServers).map(([key, val], i) => (
                    <option key={key} value={key}>{key}</option>
                ))}
            </select>
            </GenericLabel>
        </div>
    )
}
